import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../config/apiBase";
import { getAuthUserHeader } from "../utils/userRoles";
import "./MentorPage.css";
import { isStudentView } from "../utils/studentView";

export default function MentorPage() {
  const { studentId, weekId } = useParams();
  const week = Number(weekId);
  const navigate = useNavigate();
  const [page, setPage] = React.useState(null);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [submitting, setSubmitting] = React.useState(false);
  const load = React.useCallback(async () => {
    setLoading(true); setError("");
    try {
      const response = await fetch(`${API_BASE_URL}/api/mentor/weeks/${week}?student_id=${encodeURIComponent(studentId)}`, { headers: { "X-User": getAuthUserHeader() } });
      const data = await response.json();
      if (!response.ok) {
        if (response.status === 404 && String(data?.detail || "").includes("disabled")) {
          navigate(week === 4 ? `/student/${studentId}/course-complete` : `/student/${studentId}/week/${week + 1}/start`);
          return;
        }
        throw new Error(data?.detail?.message || "We could not load your Mentor review.");
      }
      setPage(data);
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  }, [navigate, studentId, week]);
  React.useEffect(() => { load(); }, [load]);
  async function continuePage() {
    if (isStudentView() || submitting || !page?.next_destination) return;
    setSubmitting(true); setError("");
    try {
      const response = await fetch(`${API_BASE_URL}/api/mentor/weeks/${week}/acknowledge`, { method: "POST", headers: { "Content-Type": "application/json", "X-User": getAuthUserHeader() }, body: JSON.stringify({ student_id: studentId }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data?.detail?.message || "Could not continue. Please try again.");
      navigate(data.next_destination);
    } catch (e) { setError(e.message); setSubmitting(false); }
  }
  if (loading) return <main className="mentor-page"><p role="status">Loading your Mentor review…</p></main>;
  if (error) return <main className="mentor-page"><p role="alert">{error}</p><button type="button" onClick={load}>Retry</button></main>;
  if (page?.status === "not_ready") return <main className="mentor-page"><p role="status">Your Mentor review is not ready yet. Please return in a moment.</p><button type="button" onClick={load}>Retry</button></main>;
  return <main className="mentor-page" aria-labelledby="mentor-heading">
    <h1 id="mentor-heading">Your Week {week} Mentor Review</h1>
    <section className="mentor-card"><h2>{page.headline}</h2><p>{page.week_summary}</p></section>
    <div className="mentor-grid"><section className="mentor-card"><h2>Strengths</h2><ul>{page.strengths.map((item) => <li key={item}>{item}</li>)}</ul></section><section className="mentor-card"><h2>Growth area</h2><p>{page.growth_area}</p></section></div>
    <section className="mentor-card"><h2>Reflection response</h2><p>{page.reflection_response}</p></section>
    <section className="mentor-card mentor-focus"><h2>Next week’s focus</h2><p>{page.next_week_advice}</p></section>
    <section className="mentor-card"><h2>Encouragement</h2><p>{page.encouragement}</p></section>
    {error && <p role="alert">{error}</p>}<button type="button" onClick={continuePage} disabled={submitting || isStudentView()}>{submitting ? "Continuing…" : "Continue"}</button>
  </main>;
}
